module.exports = __webpack_public_path__ + "img/logoffed.ec3d6121.png";